module.exports = __webpack_public_path__ + "img/74400.5ed04598.jpg";